export default "__VITE_ASSET__HP8Muao3__"